import {
    GET_CAMPAIGN_CHANNEL,
    GET_CAMPAIGN_CHANNEL_ERROR,
    CLEAN_GET_CAMPAIGN_CHANNEL,
    CLEAN_GET_CAMPAIGN_CHANNEL_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CAMPAIGN_CHANNEL:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case GET_CAMPAIGN_CHANNEL_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_GET_CAMPAIGN_CHANNEL:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_GET_CAMPAIGN_CHANNEL_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
